import { getMonitoringType } from 'app/features/configuratorData/slice/requestPayload';
import { getAttributeValue } from 'app/features/configuratorData/slice/utils';

export const getRequestPayload = (
  erpSystem,
  language,
  savedItemValues,
  savedItemFilters,
  metaDataProdTimeAttr,
  hasStemExtensions,
  hasSpeedControlBlock,
) => {
  let payload = { erpSystem, language };
  const configuratorItems = getConfiguratorItems(
    savedItemValues,
    savedItemFilters,
    hasStemExtensions,
    hasSpeedControlBlock,
  );
  const filterAttributes = getFilterAttributesofValve(
    savedItemValues,
    savedItemFilters,
    metaDataProdTimeAttr,
  );
  return { ...payload, ...filterAttributes, ...configuratorItems };
};

const getConfiguratorItems = (
  savedItemValues,
  savedItemFilters,
  hasStemExtensions,
  hasSpeedControlBlock,
) => {
  let monitoringType;
  let solenoidBasicForm;
  const actuatorBasicForm = savedItemFilters[2].filter.basicForm;
  let configBasicForm = [actuatorBasicForm];
  if (actuatorBasicForm !== 'electric_actuator') {
    if (savedItemValues[3].item !== null) {
      monitoringType = getMonitoringType(savedItemFilters[3]);
      configBasicForm.push(monitoringType);
    }
    if (savedItemValues[4].item !== null) {
      solenoidBasicForm = savedItemFilters[4].filter.basicForm;
      configBasicForm.push(solenoidBasicForm);
    }
  }
  if (
    hasStemExtensions &&
    savedItemValues[5].item !== null &&
    savedItemValues[5].item.extensions === 'STEM_EXTENSION'
  ) {
    configBasicForm.push('stem_extension');
  }
  if (
    hasSpeedControlBlock &&
    savedItemValues[5].item !== null &&
    savedItemValues[5].item.controlBlock === 'WITH_SPEED_CONTROL_BLOCKS'
  ) {
    configBasicForm.push('speed_control');
  }
  return {
    configuratorBasicForms: configBasicForm,
  };
};

const getFilterAttributesofValve = (
  savedItemValues,
  savedItemFilters,
  metaDataProdTimeAttr,
) => {
  const valveBasicForm = savedItemFilters[1].filter.basicForm;
  const valveAttributes = savedItemValues[1].item.attributes;
  const prodTimeAttr =
    metaDataProdTimeAttr.length !== 0
      ? metaDataProdTimeAttr[0]
      : 'EF023191__STRING';
  const attr = valveAttributes.find(
    x => x.attributeIdentifier === prodTimeAttr,
  );
  let value = getAttributeValue(attr);

  if (value.includes('(')) {
    value = value.split('"');
    value = value[0].trim().concat('"');
  } else if (value.includes('-')) {
    value = value.split('-');
    value = value[0].trim();
  }
  const attrIdentifier = {
    attributeIdentifier: prodTimeAttr,
    values: [value],
  };
  const filter = { basicForm: valveBasicForm, attributes: [attrIdentifier] };
  return { filter: filter };
};
